import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'

import { BookingCurrency } from '~/types/booking'

import { Donation, donationSliceStates, DonationType } from '~/donation/types/donation.types'

const INIT_DONATION_FIELDS = {
  donationAmount: 0,
  donationCurrency: BookingCurrency.USD,
  donationType: DonationType.ONE_TIME,
}

const INIT_DONATION_FIELDS_ERRORS = {
  donationAmount: '',
  donationCurrency: '',
  donationType: '',
}

const initialState: donationSliceStates = {
  donationDetails: INIT_DONATION_FIELDS,
  donationDetailsErrors: INIT_DONATION_FIELDS_ERRORS,
}

const slice = createSlice({
  name: 'donation',
  initialState,
  reducers: {
    setDonationDetails: (state, action: PayloadAction<Donation>) => ({
      ...state,
      donationDetails: action.payload,
    }),

    setDonationAmount: (state, action: PayloadAction<number>) => ({
      ...state,
      donationDetails: {
        ...state.donationDetails,
        donationAmount: action.payload,
      },
    }),

    setDonationCurrency: (state, action: PayloadAction<BookingCurrency>) => ({
      ...state,
      donationDetails: {
        ...state.donationDetails,
        donationCurrency: action.payload,
      },
    }),

    setDonationType: (state, action: PayloadAction<DonationType>) => ({
      ...state,
      donationDetails: {
        ...state.donationDetails,
        donationType: action.payload,
      },
    }),

    resetDonationDetails: (state) => ({
      ...state,
      donationDetails: initialState.donationDetails,
    }),

    setdonationDetailsFieldErrors: (state, action: PayloadAction<{ fieldName: string; value: string }>) => ({
      ...state,
      donationDetailsErrors: {
        ...state.donationDetailsErrors,
        [action.payload.fieldName]: action.payload.value,
      },
    }),
  },
})

export const selectDonationDetails = (state: RootState): Donation => state.donation.donationDetails

export const selectDonationAmount = (state: RootState): number => state.donation.donationDetails.donationAmount

export const selectDonationCurrency = (state: RootState): BookingCurrency =>
  state.donation.donationDetails.donationCurrency

export const selectDonationType = (state: RootState): string => state.donation.donationDetails.donationType

export const {
  setDonationDetails: setDonationDetailsActionCreator,
  setDonationAmount: setDonationAmountActionCreator,
  setDonationCurrency: setDonationCurrencyActionCreator,
  setDonationType: setDonationTypeActionCreator,
  resetDonationDetails: resetDonationDetailsActionCreator,
  setdonationDetailsFieldErrors: setdonationDetailsFieldErrorsActionCreator,
} = slice.actions

export default slice.reducer
